export default function scrollOffset(el, parent = document) {
  return parent.scrollTop
    + (parseInt(el.getBoundingClientRect().top, 10)
    - parseInt(parent.getBoundingClientRect().top, 10))
}
